import{styled as e}from"@mui/material/styles";import m from"@mui/icons-material/Check";const t=e(m)((({theme:e})=>({color:e.palette.success100.main})));export{t as CheckIcon};
//# sourceMappingURL=styles.js.map
